import { stringEnum } from 'common/utils/objects';

export const InventoryStatuses = stringEnum(['IN_USE', 'OUT_OF_USE', 'LOST', 'SOLD']);

export const ItemStates = stringEnum(['IN', 'OUT']);

export const FixedFieldValueOptions = stringEnum(['soleLength', 'dinVariation']);
